import { Component, OnInit, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { takeUntil, scan, startWith, take, bufferCount, mergeAll,catchError, map, concatMap, exhaustMap, withLatestFrom, filter, switchMap,takeLast,skipUntil, delay,delayWhen, tap, buffer,bufferWhen, bufferToggle  } from 'rxjs/operators';
import { iif, noop, Observable, EMPTY, of, OperatorFunction, MonoTypeOperatorFunction,from,ObservableInput, pipe } from 'rxjs';
import { routerNavigatedAction, routerRequestAction } from '@ngrx/router-store';
import {  selectIsLoggedIn } from '@store/selectors/user/user.selectors';
import { Store } from '@ngrx/store';
import {bufferWhile} from '@store/bufferWhile';




export function routerRequestActionTo<T>(url: string, checkLoggedIn: boolean = true, matchPrefix: boolean = false): OperatorFunction<Action<string>, Action<string>> {

  const urlMatches = (payloadURL: string): boolean => {
    const onlyURL = payloadURL.split('?')[0];
    return matchPrefix ? (onlyURL === url || onlyURL.startsWith(url + '/')) : onlyURL === url;
  };

   if (checkLoggedIn) {

    const loginFilter: Observable<boolean> = inject(Store).select(selectIsLoggedIn).pipe(
        filter((isLoggedIn: boolean) => {
          return isLoggedIn;
        }),
    );

    return pipe(
        ofType(routerRequestAction),
        filter((data) => urlMatches(data.payload.event.url)),
        bufferWhile(loginFilter)
    );

   } else {
    return pipe(
        ofType(routerRequestAction),
        filter((data) => urlMatches(data.payload.event.url))
    );
   }

}
